import OUTDOORLogo from "../images/OUTDOOR-logo.svg";
import OUTDOORLogoMobile from "../images/OUTDOOR-MOBILE-logo.svg";
import indexStyles from "../scss/header-outdoor.scss";
import { resaleRedirect } from "../helpers/resaleRedirect";
import { FeatureSet } from "../../common/features";
import { headerOutdoorMenus } from "./header-menus-outdoor";

const outletNav = (data, country, language) => {
  // Hide Outlet nav for NAM OR EMEA if enableOutletFlashSaleModal is true
  if (FeatureSet.enableOutletFlashSaleModal() || country.toLowerCase() === "us") {
    return "";
  }
  return `
        <li class="sale__banner__link">
            <a class="universal-black-bar__link" data-analyticsLabel="Outlet" data-linkid="header:outlet" data-url="outlet.arcteryx.com" href="https://outlet.arcteryx.com/${country}/${language}">
                ${data["Outlet Name"]}
            </a>
        </li>
    `;
};

const universalNav = (data, country, language) =>
  `
        <div class="sale__banner CN-block">
            <div class="header_content">
                <ul class="sale__banner__links">
                    <li class="sale__banner__link sale__banner__link--active">
                        <p class="active">${data["Arc'teryx Name"]}</p>
                    </li>
                    ${outletNav(data, country, language)}
                    <li class="sale__banner__link">
                        <a class="universal-black-bar__link" data-analyticsLabel="Veilance" data-linkid="header:veilance" data-url="arcteryx.com/veilance" href="https://arcteryx.com/veilance">
                            ${data["Veilance Name"]}
                        </a>
                    </li>
                    ${
                      country.toLowerCase() === "us" || country.toLowerCase() === "ca"
                        ? `<li class="sale__banner__link">
                        <a class="universal-black-bar__link" data-analyticsLabel="RESALE" data-linkid="header:resale" data-url="${resaleRedirect(
                          country,
                          language
                        )}" href="https://www.${resaleRedirect(country, language)}">
                            ${data.RESALE}
                        </a>
                    </li>`
                        : ""
                    }
                </ul>
            </div>
        </div>
    `;
const headerHtml = ({ data, country, language }) => `<div class="OUTDOOR NOTLOGGEDIN">
        <style type="text/css">
            ${indexStyles}
        </style>
        ${universalNav(data, country, language)}
                    
        <div class="header">
            <!-- Header Messaging Banner -->
            <div class="header-info">
                <div class="header-info-contents">
                
                    <span class="header-info__message">
                    </span>
                </div>
            </div>
            
            <!-- / Header Checkout -->
            <div class="header__checkout-heading">
                <div class="checkout-heading">${data.Checkout}</div>
            </div>

            <!-- / Header Messaging Banner -->
            <div class="header-content__wrapper">
                <div class="header_content">
                    <div class="header-content__left">
                        <div class="header-logo" style="display: none;">
                            <a class="logo" href="/" title="Arc'teryx"><span>Arc'teryx</span>${OUTDOORLogo}${OUTDOORLogoMobile}</a>
                        </div>
                        ${headerOutdoorMenus({ data, language, country })}
                    </div>

                    <div class="header-content__right">
                        <div class="header-search" aria-label="Search">
                        <span class="search">${data.Search}</span>
                        <span class="icon-search"></span>
                        </div>
                        <div id="right-nav">
                            <cart>
                                <div id="cartSummary">
                                <a id="cartInfo" href="/cart" rel="noindex, nofollow">
                                  <span id="cartItems"></span>
                                  <span class="visually-hidden">View Cart</span>
                                </a>
                                </div>
                            </cart>
                            <span class="flag flag"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /header -->`;

export default headerHtml;
